import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import "./assets/css/Header.css"
// import "./assets/css/home.css"
// import "./assets/css/Management.css"
import "./assets/css/Style.css"

import NotFoundPage from "./404Page";
import ErrorBoundary from "./ErrorBoundary";
import LowercaseRedirect from "./LowercaseRedirect";
import Home from "./home";

import SchoolDetails from "./SchoolDetails";
import CourseDetails from "./CourseDetails";

import AboutUs from "./about/AboutUs";
import VisionMission from "./about/VisionMission";
import LeadershipAndManagement from "./about/LeadershipAndManagement";
import UniversityAdministration from "./about/UniversityAdministration";
import HonorableVisitor from "./about/HonorableVisitor";
import HonorablePatron from "./about/HonorablePatron";
import HonorableChancellor from "./about/HonorableChancellor";
import HonorableViceChancellor from "./about/HonorableViceChancellor";
import HonorableRegistrar from "./about/HonorableRegistrar";
import Awards from "./about/Awards";
import Iqac from "./about/Iqac";
import DignitariesMessages from "./about/DignitariesMessages";
import CodeOfConductBoardesOfHostel from "./about/CodeOfConductBoardesOfHostel";
import CodeOfConductManagement from "./about/CodeOfConductManagement";
import CodeOfConductFaculty from "./about/CodeOfConductFaculty";
import CodeOfConductStudent from "./about/CodeOfConductStudent";
import CodeOfConduct from "./about/CodeOfConduct";
import RTI from "./about/RTI";
import StatuesAndOrdinance from "./about/StatuesAndOrdinance";
import GoverningBody from "./about/GoverningBody";
import AccreditationAndRecognitions from "./about/AccreditationAndRecognitions";
import BoardManagement from "./about/BoardManagement";
import AcademicCouncil from "./about/AcademicCouncil";
import BoardOfAdvisors from "./about/BoardOfAdvisors";
import OtherCommunitie from "./about/OtherCommunitie";
import MediaCoverage from "./about/MediaCoverage";
import FacultyList from "./about/FacultyList";
import AccreditationNaac from "./about/AccreditationNaac";
import AccreditationAacsb from "./about/AccreditationAacsb";
import AccreditationIau from "./about/AccreditationIau";
import ContactUs from "./about/ContactUs";
import NewsEvents from "./about/NewsEvents";

import AcademicPhilosophy from "./academics/AcademicPhilosophy";
import AcademicPartner from "./academics/AcademicPartner";
import AcademicSyllabus from "./academics/AcademicSyllabus";
import TeachingMethodologyPedagogy from "./academics/TeachingMethodologyPedagogy";
import OnlineResources from "./academics/OnlineResources";
import MoocWithIsbm from "./academics/MoocWithIsbm";
import MousAndCollaborations from "./academics/MousAndCollaborations";
import GraduateProgrammes from "./academics/GraduateProgrammes";
import PostGraduateProgrammes from "./academics/PostGraduateProgrammes";
import DiplomaProgrammes from "./academics/DiplomaProgrammes";
import CertificateProgrammes from "./academics/CertificateProgrammes";
import AcademicCalender from "./academics/AcademicCalender";
import Blog from "./academics/Blog";
// import BlogDetails from "./academics/BlogDetails/";

import ProspectiveInternationalStudents from "./international/ProspectiveInternationalStudents";
import InternationalPartnerships from "./international/InternationalPartnerships";
import InternationalStudents from "./international/InternationalStudents";

const App = () => {
  const [isRootEmpty, setIsRootEmpty] = useState(false);

  useEffect(() => {
    const rootDiv = document.getElementById("root");
    if (!rootDiv || rootDiv.innerHTML.trim() === "") {
      setIsRootEmpty(true);
    }
  }, []);

  if (isRootEmpty) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Router>
      <ErrorBoundary>
        {/* Redirect to lowercase if needed */}
        <LowercaseRedirect />
        <Routes>
          {/* Default route */}
          <Route path="/" element={<Home />} />

          {/* Aliases for home */}
          <Route path="/home" element={<Navigate to="/" replace />} />

          {/* Schools */}
          <Route
            path="/school/:schoolName"
            element={<SchoolDetails />}
          />
          {/* courses */}
          <Route
            path="/course/:courseName"
            element={<CourseDetails />}
          />

          {/* About Us */}
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/vision-mission" element={<VisionMission />} />
          <Route path="/leadership-and-management" element={<LeadershipAndManagement />} />
          <Route path="/university-administration" element={<UniversityAdministration />} />
          <Route path="/honorable-visitor" element={<HonorableVisitor />} />
          <Route path="/honorable-patron" element={<HonorablePatron />} />
          <Route path="/honorable-chancellor" element={<HonorableChancellor />} />
          <Route path="/honorable-vice-chancellor" element={<HonorableViceChancellor />} />
          <Route path="/honorable-registrar" element={<HonorableRegistrar />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/iqac" element={<Iqac />} />
          <Route path="/dignitaries-messages" element={<DignitariesMessages />} />
          <Route path="/code-of-conduct-boardes-of-hostel" element={<CodeOfConductBoardesOfHostel />} />
          <Route path="/code-of-conduct-management" element={<CodeOfConductManagement />} />
          <Route path="/code-of-conduct-faculty" element={<CodeOfConductFaculty />} />
          <Route path="/code-of-conduct-student" element={<CodeOfConductStudent />} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="/rti" element={<RTI />} />
          <Route path="/statues-and-ordinance" element={<StatuesAndOrdinance />} />
          <Route path="/governing-body" element={<GoverningBody />} />
          <Route path="/accreditation-and-recognitions" element={<AccreditationAndRecognitions />} />
          <Route path="/board-management" element={<BoardManagement />} />
          <Route path="/academic-council" element={<AcademicCouncil />} />
          <Route path="/board-advisor" element={<BoardOfAdvisors />} />
          <Route path="/other-committees" element={<OtherCommunitie />} />
          <Route path="/media-coverage" element={<MediaCoverage />} />
          <Route path="/faculty-list" element={<FacultyList />} />
          <Route path="/naac-accreditation" element={<AccreditationNaac />} />
          <Route path="/aacsb-accreditation" element={<AccreditationAacsb />} />
          <Route path="/iau-accreditation" element={<AccreditationIau />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/news-events" element={<NewsEvents />} />

          {/* Academics */}
          <Route path="/academic-philosophy" element={<AcademicPhilosophy />} />
          <Route path="/academic-partner" element={<AcademicPartner />} />
          <Route path="/academic-syllabus" element={<AcademicSyllabus />} />
          <Route path="/teaching-methodology-pedagogy" element={<TeachingMethodologyPedagogy />} />
          <Route path="/online-resources" element={<OnlineResources />} />
          <Route path="/mooc-with-isbm" element={<MoocWithIsbm />} />
          <Route path="/mous-and-collaborations" element={<MousAndCollaborations />} />
          <Route path="/graduate-programmes" element={<GraduateProgrammes />} />
          <Route path="/post-graduate-programmes" element={<PostGraduateProgrammes />} />
          <Route path="/diploma-programmes" element={<DiplomaProgrammes />} />
          <Route path="/certificate-programmes" element={<CertificateProgrammes />} />
          <Route path="/academic-calender" element={<AcademicCalender />} />
          <Route path="/blog" element={<Blog />} />
          {/* <Route path="/blog/:url" element={<BlogDetails />} /> */}

          {/* International */}
          <Route path="/prospective-international-students" element={<ProspectiveInternationalStudents />} />
          <Route path="/international-partnerships" element={<InternationalPartnerships />} />
          <Route path="/international-students" element={<InternationalStudents />} />

          {/* 404 Handling */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
};

export default App;